export default {"src":"/pro/_next/static/media/bnb.cefe75c8.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};